// We never use `eval`, so an `<anonymous>` frame with a line number must be injected code such as a browser extension.
export function isInjectedScriptError(event) {
  const values = event.exception?.values ?? [];
  const frames = values[values.length - 1]?.stacktrace?.frames ?? [];
  const thrownFrom = [...frames]
    .reverse()
    .find((frame) => frame.lineno !== undefined);

  return thrownFrom?.filename === "<anonymous>";
}
